module.exports = __webpack_public_path__ + "img/teal-blur.svg";